const Replace2x = (props) => {
   return  props === null ? console.log() :
    props.replace('"','').replace('"','').toString();
}

export default Replace2x;
